if (!customElements.get('custom-variant-selector')) {
  customElements.define('custom-variant-selector', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', (ev) => {
        const el = ev.target;
        const dataTarget =
          el.tagName === 'SELECT'
            ? el.selectedOptions[0]
            : el.closest('[data-variant-id]');

        if (dataTarget && dataTarget.dataset.variantId && dataTarget.dataset.price) {
          const productId = el.value;
          const variantId = dataTarget.dataset.variantId;
          const price = dataTarget.dataset.price;
          const compareAtPrice = dataTarget.dataset.compareAtPrice;
          const savings = dataTarget.dataset.savings;

          document.querySelectorAll('.js-product-info-wrapper input[name="id"]').forEach((input) => {
            input.value = variantId;
          });
          document.querySelectorAll('.js-add-to-cart-price').forEach((priceEl) => {
            priceEl.innerHTML = price.replace(/\s+/g, '');
          });

          document.querySelectorAll('.js-submit-button-compare-at-price').forEach((el) => {
            if (compareAtPrice) {
              el.innerHTML = compareAtPrice.replace(/\s+/g, '');
              el.classList.remove('hidden');
            } else {
              el.classList.add('hidden');
            }
          });

          document.querySelectorAll('.js-submit-button-discount-badge').forEach((el) => {
            if (savings && savings !== '0') {
              el.innerHTML = `AHORRA UN ${savings}%`;
              el.classList.remove('hidden');
            } else {
              el.classList.add('hidden');
            }
          });

          const selectedLabel = this.querySelector('[data-selected-value]');
          if (selectedLabel && dataTarget.dataset.packLabel) {
            selectedLabel.textContent = dataTarget.dataset.packLabel;
          }

          document.dispatchEvent(
            new CustomEvent('custom-variant-changed', {
              detail: { productId, variantId, price },
            }),
          );
        }
      });
    }
  });
}